import api from '../config/api';

const configuracionPlanillaAlternativaService = {
  async obtenerConfiguracion(empresaId) {
    try {
      const response = await api.get(`/configuracion-planilla-alternativa/empresa/${empresaId}`);
      return response.data;
    } catch (error) {
      if (error.response?.status === 404) {
        return { success: false, error: 'Empresa no encontrada' };
      }
      return {
        success: false,
        error: error.response?.data?.error || 'Error al obtener configuración de planilla alternativa',
      };
    }
  },

  async actualizarConfiguracion(empresaId, activo) {
    try {
      const response = await api.put(`/configuracion-planilla-alternativa/empresa/${empresaId}`, {
        activo: Boolean(activo),
      });
      return response.data;
    } catch (error) {
      if (error.response?.status === 404) {
        return { success: false, error: 'Empresa no encontrada' };
      }
      if (error.response?.status === 422) {
        return {
          success: false,
          error: 'Datos de entrada inválidos',
          details: error.response.data.details,
        };
      }
      return {
        success: false,
        error: error.response?.data?.error || 'Error al actualizar configuración de planilla alternativa',
      };
    }
  },

  async verificarEstado(empresaId) {
    try {
      const response = await api.get(`/configuracion-planilla-alternativa/empresa/${empresaId}/estado`);
      return response.data;
    } catch (error) {
      if (error.response?.status === 404) {
        return { success: false, error: 'Empresa no encontrada' };
      }
      return {
        success: false,
        error: error.response?.data?.error || 'Error al verificar estado de planilla alternativa',
      };
    }
  },
};

export default configuracionPlanillaAlternativaService;
